var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiesel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05,7.48a.62.62,0,0,1-.61-.61.61.61,0,1,1,1.22,0A.62.62,0,0,1,12.05,7.48Zm-3.64,0H4.78V4.42H8.41Zm0,2.14V13H4.78V8.7H8.41Zm4.71-3.83h0L10.87,3.51l-.64.65,1.28,1.28a1.53,1.53,0,0,0,.54,3,1.55,1.55,0,0,0,.61-.13v4.4a.61.61,0,1,1-1.22,0V9.92A1.22,1.22,0,0,0,10.23,8.7h-.6V4.42A1.22,1.22,0,0,0,8.41,3.2H4.78A1.22,1.22,0,0,0,3.56,4.42V14.2H9.63V9.62h.9v3.05a1.52,1.52,0,1,0,3,0V6.87A1.49,1.49,0,0,0,13.12,5.79Z",
    transform: "translate(-3.56 -3.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiesel);
export default __webpack_public_path__ + "static/media/diesel.587fb644cf0df0275a4733f55495e900.svg";
export { ForwardRef as ReactComponent };